import { once } from '../public-utils/once';

// using `cache` as our `isAndroid()` result will not change in a browser
export var isAndroid = once(function isAndroid() {
  return navigator.userAgent.toLocaleLowerCase().includes('android');
});
export var androidFallbackText = 'pdnd:android-fallback';